export default "__VITE_ASSET__e1f802d7__"